import { Injectable, ViewContainerRef } from '@angular/core';
import { NotificationService, NotificationSettings, Position } from "@progress/kendo-angular-notification";
import { NotificationComponent } from '../components/notification/notification.component';

@Injectable({
  providedIn: 'root'
})
export class INotificationService {

  constructor(private notifyService: NotificationService) { }

  text: string;
  description: string
  position: {
    horizontal: string;
    vertical: string;
  };

  show(settings: INotificationSettings) {
    this.text = settings.title;
    this.description = settings.description ?? "";
    settings.timeout = settings.timeout ?? 7000;

    this.notifyService.show({
      appendTo: settings.containerRef,
      content: NotificationComponent,
      hideAfter: settings.timeout,
      animation: { type: "fade", duration: 500 },
      type: { style: settings.type, icon: true },
      position: settings.position ?? { horizontal: "right", vertical: "bottom" }
      // Can't have both timeout and an X to manually close
      //closable: true
    });
  }
}


export interface INotificationSettings {
  containerRef?: ViewContainerRef; // notification will show inside a specific container element instead of the entire window
  title: string;
  description?: string;
  type: 'success' | 'error' | 'warning' | 'info';
  timeout?: number; // Default will be 7000 = 7 seconds
  position?: {
    horizontal: 'left' | 'center' | 'right';
    vertical: 'top' | 'bottom';
  };
}
